export function AssetLibEntryVideo(props: { data : any }) {

  return (
    <div className='gallery_product col-lg-2 col-md-2 col-sm-3 col-xs-6' >
      <iframe className='box-wh' src={props.data.file} title="coding iframe"/>
      <p className='text-center'>{props.data.name}</p>
    </div>
    );
}
